<div class="modal-header">
  <h5 class="modal-title">Payslip Preview</h5>
  <button
    type="button"
    class="btn-close custom-btn-close"
    data-bs-dismiss="modal"
    aria-label="Close"
    (click)="onClose()"
  >
    <i class="ti ti-x"></i>
  </button>
</div>
<div #payslipContainerToExport id="payslip-container">
  <div class="row">
    <div class="col-sm-12">
      <div class="card border-0">
        <div class="card-body">
          <div class="row align-items-center mb-3">
            <div class="col-md-2 text-start">
              <!-- <div class="d-flex align-items-center">
                <div class="overflow-hidden mb-2" style="width: 100px; height: 50px"> -->
              <img
                [src]="imageBaseUrl + payrollData.businessLogo"
                class="img-fluid responsive-logo"
                alt="logo"
                style="max-height: 70px; object-fit: contain"
              />
              <!-- </div>
              </div> -->
            </div>
            <div class="col-md-8 text-center">
              <h4>{{ payrollData.businessName }}</h4>
              <br />
              <p class="mb-1">{{ payrollData.businessAddress }}</p>
              <p class="mb-1">{{ businessLocation }}</p>
            </div>
            <!-- <div class="col-md-6">
              <div class="text-end mb-3">
                <p class="mb-0">Salary Month</p>
                <p class="text-dark">
                  {{ payPeriodStartDate | date: 'MMM' }}, {{ payPeriodStartDate | date: 'yyyy' }}
                </p>
              </div>
            </div> -->
            <h5 class="text-center mt-4 mb-2">
              Payslip for the month of {{ payPeriodStartDate | date: 'MMM' }}
              {{ payPeriodStartDate | date: 'yyyy' }}
            </h5>
          </div>
          <div class="row payroll-border mb-3 m-1">
            <!-- LEFT COLUMN -->
            <div class="col-md-6 payroll-col-right-border">
              <div class="p-3">
                <div class="row mb-1">
                  <div class="col-5 text-dark fw-bold">Name</div>
                  <div class="col-7 text-dark">
                    {{ payrollData.employee.firstName }} {{ payrollData.employee.lastName }}
                  </div>
                </div>

                <div class="row mb-1">
                  <div class="col-5 text-dark fw-bold">Employee ID</div>
                  <div class="col-7 text-dark">{{ payrollData.employee.empId }}</div>
                </div>

                <div class="row mb-1">
                  <div class="col-5 text-dark fw-bold">Designation</div>
                  <div class="col-7 text-dark">
                    {{ payrollData.employee.designation?.designationName }}
                  </div>
                </div>

                <div class="row mb-1">
                  <div class="col-5 text-dark fw-bold">Date of Joining</div>
                  <div class="col-7 text-dark">
                    {{ payrollData.employee.joiningDate | date: 'MMM dd, yyyy' }}
                  </div>
                </div>

                <div class="row mb-1">
                  <div class="col-5 text-dark fw-bold">Date of Birth</div>
                  <div class="col-7 text-dark">
                    {{ payrollData.employee.birthdate | date: 'MMM dd, yyyy' }}
                  </div>
                </div>
              </div>
            </div>

            <!-- RIGHT COLUMN -->
            <div class="col-md-6">
              <div class="p-3">
                <div class="row mb-1">
                  <div class="col-5 text-dark fw-bold">Total no. of Paid Days</div>
                  <div class="col-7 text-dark">{{ daysInMonth }}</div>
                </div>

                <div class="row mb-1">
                  <div class="col-5 text-dark fw-bold">Payable Days</div>
                  <div class="col-7 text-dark">{{ daysInMonth - payrollData.lopDays }}</div>
                </div>

                <div class="row mb-1">
                  <div class="col-5 text-dark fw-bold">LOP Days</div>
                  <div class="col-7 text-dark">{{ payrollData.lopDays }}</div>
                </div>

                <div class="row mb-1">
                  <div class="col-5 text-dark fw-bold">Bank Name</div>
                  <div class="col-7 text-dark">{{ payrollData.bankName }}</div>
                </div>

                <div class="row mb-1">
                  <div class="col-5 text-dark fw-bold">Bank Account Number</div>
                  <div class="col-7 text-dark">{{ payrollData.bankAccountNumber }}</div>
                </div>

                <div class="row mb-1">
                  <div class="col-5 text-dark fw-bold">PAN</div>
                  <div class="col-7 text-dark">{{ payrollData.pan }}</div>
                </div>

                <div class="row mb-1" *ngIf="payrollData.esiNumber">
                  <div class="col-5 text-dark fw-bold">ESI No.</div>
                  <div class="col-7 text-dark">{{ payrollData.esiNumber }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="row payroll-border mb-3 m-1">
            <!-- EARNINGS (LEFT) -->
            <div class="col-md-6 payroll-col-right-border p-0">
              <div class="d-flex flex-column h-100" style="padding: 10px 12px 5px 12px">
                <div class="row border-bottom border-dark">
                  <!-- <div class="col-7 fw-bold">Total Earnings</div>
                  <div class="col-5 text-end fw-bold">
                    {{ payrollData.grossSalary | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN' }}
                  </div> -->
                  <h6 class="d-flex justify-content-between align-items-center mb-2">
                    <span>Earnings</span><span> Amount </span>
                  </h6>
                </div>
                <!-- Header with bottom border -->
                <!-- <h6
                  class="mb-2 border-bottom pb-1 d-flex justify-content-between align-items-center"
                >
                  <span>Earnings</span>
                  <span class="fw-medium"> Amount </span>
                </h6> -->

                <!-- Earnings List -->
                <div class="flex-grow-1 mt-2">
                  <div
                    class="row mb-1"
                    *ngFor="let earning of payrollData.calculationBreakdown?.earnings"
                    [hidden]="earning.amount <= 0"
                  >
                    <div class="col-7 text-dark">{{ earning.name }}</div>
                    <div class="col-5 text-end text-dark">
                      {{ earning.amount | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN' }}
                    </div>
                  </div>
                </div>

                <!-- Footer: Total Earnings with top border -->
                <div class="row border-top mt-2 border-dark" style="padding: 10px 0px 5px 0px">
                  <!-- <div class="col-7 fw-bold">Total Earnings</div>
                  <div class="col-5 text-end fw-bold">
                    {{ payrollData.grossSalary | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN' }}
                  </div> -->
                  <h6 class="d-flex justify-content-between align-items-center">
                    <span>Total Earnings</span>
                    <span>
                      {{ payrollData.grossSalary | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN' }}
                    </span>
                  </h6>
                </div>
              </div>
            </div>

            <!-- DEDUCTIONS (RIGHT) -->
            <div class="col-md-6 p-0">
              <div class="d-flex flex-column h-100" style="padding: 10px 12px 5px 12px">
                <!-- Header with bottom border -->
                <!-- <h6
                  class="mb-2 border-bottom pb-1 d-flex justify-content-between align-items-center"
                >
                  <span>Deductions</span>
                  <span class="fw-medium"> Amount </span>
                </h6> -->

                <div class="row border-bottom border-dark">
                  <!-- <div class="col-7 fw-bold">Total Earnings</div>
                  <div class="col-5 text-end fw-bold">
                    {{ payrollData.grossSalary | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN' }}
                  </div> -->
                  <h6 class="d-flex justify-content-between align-items-center mb-2">
                    <span>Deductions</span><span> Amount </span>
                  </h6>
                </div>

                <!-- Deductions List -->
                <div class="flex-grow-1 mt-2">
                  <div
                    class="row mb-1"
                    *ngFor="let deduction of payrollData.calculationBreakdown?.deductions"
                    [hidden]="deduction.amount <= 0 || deduction.name === 'LOP'"
                  >
                    <div class="col-7 text-dark">{{ deduction.name }}</div>
                    <div class="col-5 text-end text-dark">
                      {{ deduction.amount | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN' }}
                    </div>
                  </div>

                  <div class="row mb-1" *ngIf="payrollData.tdsAfterCess > 0">
                    <div class="col-7 text-dark">TDS After CESS</div>
                    <div class="col-5 text-end text-dark">
                      {{
                        payrollData.tdsAfterCess | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN'
                      }}
                    </div>
                  </div>
                </div>

                <!-- Footer: Total Deductions with top border -->
                <div class="row border-top mt-2 border-dark" style="padding: 10px 0px 5px 0px">
                  <!-- <div class="col-7 fw-bold"><h6>Total Deductions</h6></div>
                  <div class="col-5 text-end fw-bold">
                    {{ totalDeductions | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN' }}
                  </div> -->

                  <h6 class="d-flex justify-content-between align-items-center">
                    <span>Total Deductions</span>
                    <span>
                      {{ totalDeductions | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN' }}
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>

          <!-- NET / GROSS SUMMARY -->
          <div>
            <p class="mb-0 text-dark ms-2">
              Gross Payment :
              <span>
                {{ payrollData.grossSalary | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN' }}</span
              >
            </p>
            <br />
            <p class="mb-0 text-dark ms-2">
              Deductions :
              <span> {{ totalDeductions | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN' }}</span>
            </p>
            <br />
            <p class="text-gray-9 fw-medium ms-2">
              Total Payable :
              <span class="text-gray-9 fw-medium">
                {{
                  payrollData.grossSalary - totalDeductions + lopDeductionAmount
                    | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN'
                }}
                <!-- {{ payrollData.grossSalary | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN' }} -->
              </span>
            </p>
            <!-- <p class="text-gray-9 fw-medium">
              Total Payable :
              <span class="text-gray-9 fw-medium">
                {{ payrollData.grossSalary | currency: 'INR' : 'symbol' : '1.2-2' : 'en-IN' }}</span
              >
            </p> -->
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <p class="small">This is a system generated payslip and do not require signature.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="download" style="text-align: center; margin-bottom: 20px; margin-top: 20px">
  <button (click)="downloadPayslipPDF()" class="btn btn-primary" [disabled]="!payrollData">
    Download as PDF
  </button>
</div>
